import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { clusterState } from './state';
import { baseSelectors } from './selectors';

const clusterSlice = createSlice({
  name: 'runForm',
  initialState: clusterState,
  reducers: {
    setFilters: (state, action: PayloadAction<{ [key: string]: string }>) => {
      state.filters = { ...state.filters, [action.payload.name]: action.payload.value };
    },
  },
});

export const clusterToolkit = Object.freeze({
  clusterState,
  actions: clusterSlice.actions,
  selectors: {
    ...baseSelectors,
  },
});
export const clusterModuleReducer = clusterSlice.reducer;
